import React, { useEffect, useState } from 'react';
import { Loader2 } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '../../ui/dialog';
import { pulizieApi } from './api';

const data = (iso) => (iso ? iso.split('-').reverse().join('/') : '');

export const ProdottiDialog = ({ open, onClose }) => {
  const [dati, setDati] = useState(null);
  useEffect(() => { if (open) pulizieApi.get('/prodotti').then(setDati).catch(() => setDati({ prodotti: [], tipi: {} })); }, [open]);

  const gruppi = (dati?.prodotti || []).reduce((acc, p) => ({ ...acc, [p.tipo]: [...(acc[p.tipo] || []), p] }), {});
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-lg rounded-2xl max-h-[88vh] overflow-y-auto" data-testid="pulizie-prodotti-dialog">
        <DialogHeader>
          <DialogTitle>Detergenti dalle fatture</DialogTitle>
          <DialogDescription>Li trovo da solo nelle fatture e li uso nel piano e nel PDF.</DialogDescription>
        </DialogHeader>
        {!dati ? <Loader2 className="h-6 w-6 animate-spin mx-auto text-gray-400" />
          : !dati.prodotti.length ? <p className="text-sm text-gray-500 text-center py-4">Nessun prodotto per la pulizia nelle fatture</p>
            : Object.entries(gruppi).map(([tipo, lista]) => (
              <div key={tipo} data-testid={`pulizie-prodotti-${tipo}`}>
                <h4 className="text-xs font-semibold uppercase tracking-wide text-gray-500">{dati.tipi[tipo]}</h4>
                {lista.map((p) => (
                  <div key={p.nome} className="py-2 border-b border-gray-200 last:border-0">
                    <p className="text-sm text-gray-900">{p.nome}</p>
                    <p className="text-xs text-gray-500">{p.fornitore} · ultimo acquisto {data(p.ultimo_acquisto)}</p>
                  </div>
                ))}
              </div>
            ))}
        <p className="text-xs text-gray-600 rounded-xl bg-amber-50 border border-amber-200 p-3">
          Per ogni prodotto tieni la scheda tecnica e la scheda di sicurezza. Per disinfettare serve un prodotto con scritto
          in etichetta "Presidio Medico Chirurgico" o il numero di registrazione del biocida.
        </p>
      </DialogContent>
    </Dialog>
  );
};
